
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import AlertErrorForm from "../component/AlertErrorForm";
import Spinner from "../component/Spinner";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { Link, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import SearchBoxModal from "../component/SearchBoxModal";


export default function FormNghiCheDo() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [dateSelect, setDateSelect] = useState({ datestart: null, dateend: null });

    const defaultdetail = {
        title: '', author_id: user.data.id, datestart: null, dateend: null, number: '', status: 0, text_status: 'TS'
    }
    useEffect(
        function () {
            if (id > 0) {
                let mounted = true;
                Axios.get(URL_LIST_ALL + "nghichedo/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            if (mounted) {
                                let data_detail = res.data.data
                                if (data_detail && data_detail.users_join && data_detail.users_join != '') {
                                    data_detail.users_join = JSON.parse(data_detail.users_join)
                                }
                                setDetail(data_detail);
                                const date_start = data_detail.datestart
                                const date_end = data_detail.dateend
                                setDateSelect({ datestart: date_start, dateend: date_end })
                            }
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
                return () => (mounted = false);
            }
        }, [user, id, refresh]
    );
    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().trim().nullable().required('Nhập tên ngày nghỉ').max(150, "Độ dài không quá 150 ký tự"),
            datestart: Yup.string().trim().nullable().required('Chọn ngày'),
            user_id: Yup.string().trim().nullable().required('Chọn nhân sự'),
            text_status: Yup.string().trim().nullable().required('Nhập trạng thái công'),
        }),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'nghichedo/' + id, values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật nghỉ chế độ thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                // console.log(values);
                Axios.post(URL_LIST_ALL + 'nghichedo', values, user.config).then(res => {
                    setLoading(false);
                    setSubmitting(false);
                    setRefresh(!refresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới nghỉ chế độ thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const handleDate = (name, value) => {
        formik.setFieldValue(name, value ? moment(value).format('YYYY-MM-DD') : null)
        formik.setFieldTouched(name)
        let newDate = Object.assign({}, dateSelect)
        newDate[name] = value
        setDateSelect(newDate)
    };
    return (
        <AkkhorLayout idrole="che-do">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/che-do">Danh sách nghỉ chế độ</Link>
                    </li>
                    <li>{id ? 'Sửa nghỉ chế độ' : 'Thêm mới nghỉ chế độ'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Cài đặt nghỉ chế độ</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-lg-8 col-12 form-group">
                                <label>Tiêu đề <span className="text-danger">*</span></label>
                                <input type="text" placeholder="" className="form-control height32" {...formik.getFieldProps("title")} autoComplete="off" />
                                <AlertErrorForm formik={formik} name="title"></AlertErrorForm>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-md-4 col-12 form-group">
                                <label>Thời gian bắt đầu </label>
                                <DateTimePicker onChange={(value) => { handleDate('datestart', value) }} value={dateSelect.datestart ? new Date(dateSelect.datestart) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                                <AlertErrorForm formik={formik} name="datestart"></AlertErrorForm>
                            </div>
                            <div className="col-md-4 col-12 form-group">
                                <label>Thời gian kết thúc </label>
                                <DateTimePicker onChange={(value) => { handleDate('dateend', value) }} value={dateSelect.dateend ? new Date(dateSelect.dateend) : null} format="dd-MM-y" className="form-control height32 air-datepicker"></DateTimePicker>
                            </div>
                            <div className="col-xs-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái công </label>
                                <input type="text" placeholder="VD: TS" className="form-control height32" {...formik.getFieldProps("text_status")} />
                                <small>Thai sản - TS;</small>
                                <AlertErrorForm formik={formik} name="text_status"></AlertErrorForm>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-12 col-sm-3 form-group">
                                <label>Chọn nhân sự </label>
                                <SearchBoxModal apiname={"users"} placeholder="Chọn nhân sự" colvalue={'id'} colname={'title'} defaultValue={formik.values['user_id']} name='users' 
                                    onChange={async (e) => {
                                        await formik.setFieldValue('user_id', e)
                                    }}></SearchBoxModal>
                            </div>
                            <div className="col-12"></div>
                            <div className="col-sm-4 col-12 form-group">
                                <label>Trạng thái</label>
                                <select className="form-select height32" {...formik.getFieldProps("status")}>
                                    <option value="0">Ngừng kích hoạt</option>
                                    <option value="1">Kích hoạt</option>
                                </select>
                            </div>
                            <div className="col-12 form-group mg-t-8">
                                <button type="submit" disabled={formik.isSubmitting} className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark">{loading ? <Spinner /> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn-fill-lg bg-blue-dark btn-hover-yellow">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
